export default __webpack_public_path__ + "static/10_27-9b6d318d9281764b94cb157d7a66044c.png";